import React from 'react';
import { Link } from 'react-router-dom';
import './Pages.css';

const Store = () => {
  return (
    <div className="page-container store-page">
      <div className="store-preview-container">
        {/* <h2 className="store-title">STORE</h2> */}
        <div className="store-grid">
          <Link to="/store/kurupt-tee" className="store-item kurupt-tee-item">
            <div className="store-image-container">
              <img src={require('../assets/store/KURUPT TEE.png')} alt="Kurupt Tee" className="store-image kurupt-front" />
              <img src={require('../assets/store/KURUPT TEE BACK.png')} alt="Kurupt Tee Back" className="store-image kurupt-back" />
            </div>
            <div className="store-info">
              <p className="store-item-subtitle" style={{color: 'green'}}>NEW!</p>
              <h3 className="store-item-title">Kurupt FM Heavy Tee</h3>
              <p className="store-item-price">£35</p>
            </div>
          </Link>

          <Link to="/store/satellite-tee" className="store-item satellite-tee-item">
            <div className="store-image-container">
              <img src={require('../assets/store/SATELLITE TEE FRONT.png')} alt="Satellite Tee" className="store-image satellite-front" />
              <img src={require('../assets/store/SATELLITE TEE BACK.png')} alt="Satellite Tee Back" className="store-image satellite-back" />
            </div>
            <div className="store-info">
              <p className="store-item-subtitle" style={{color: 'green', zIndex: '999'}}>NEW!</p>
              <h3 className="store-item-title">Satellite Heavy Tee</h3>
              <p className="store-item-price">£30</p>
            </div>
          </Link>

          <Link to="/store/og-tee" className="store-item">
            <div className="store-image-container">
              <img src={require('../assets/store/OG Tee.png')} alt="OG Tee" className="store-image" />
            </div>
            <div className="store-info">
              <p className="store-item-subtitle" style={{color: 'white'}}>NEW!</p>
              <h3 className="store-item-title">OG Heavy Tee</h3>
              <p className="store-item-price">£30</p>
            </div>
          </Link>
          
          <Link to="/store/eyes-tee" className="store-item">
            <div className="store-image-container">
              <img src={require('../assets/store/Eyes Tee.png')} alt="Eyes Tee" className="store-image" />
            </div>
            <div className="store-info">
              <p className="store-item-subtitle" style={{color: 'red'}}>NEW!</p>
              <h3 className="store-item-title">Eyes Heavy Tee</h3>
              <p className="store-item-price">£30</p>
            </div>
          </Link>
          
          <Link to="/store/clash-tee" className="store-item">
            <div className="store-image-container">
              <img src={require('../assets/store/Clash Mag Tee.png')} alt="Clash Tee" className="store-image" />
            </div>
            <div className="store-info">
              <p className="store-item-subtitle" style={{color: 'yellow'}}>SOLD OUT</p>
              <h3 className="store-item-title">Clash Tee</h3>
              <p className="store-item-price">£25</p>
            </div>
          </Link>
        </div>
      </div>
    </div>
  );
};

export default Store; 